import { getNow } from '@/pages/utils/tool';
import LaonhfcModel from './LaonhfcModel';
import PaymentInfoModel from './PaymentInfoModel';
import CaseInsureModel from './CaseInsureModel';
import UseCaseModel from './UseCaseModel';

export default class ApplicationModel {
  constructor() {
    this.tab = '1'; // 1:新 or 2:舊案
    this.caseId = Math.uuidFast();
    this.caseType = 0; // 0優加 1優質 2一般 3超優
    this.caseStatus = 0;
    this.displayId = ''; // 案件編號
    this.category = 0; // 0:機車原融 / 購車分期，產品分類
    this.platform = 0; // 0裕富 1和潤 2中租 3高踞 4嘉好，增加廠商
    this.header = {
      caseType: '', // 0%
      caseType1: '', // 保險專案 / A
      caseType2: '', // 信用卡專案 / B
      caseType3: '', // 設定 / C
      caseType4: '', // 優值
      caseType5: '', // 超優
      type: [
        { key: 0, value: false }, // 優加
        { key: 1, value: false }, // 一般
      ],
      caType: [
        { key: 0, value: false }, // A
        { key: 1, value: false }, // B
        { key: 2, value: false }, // C
        { key: 3, value: false }, // C
      ],
    };
    this.applyDisplayDate = '';
    this.applyDate = { // 申請日期
      year: '',
      month: '',
      day: '',
      isRepublic: false,
      disabled: false,
    };
    this.customer = { // 基本資料
      name: '',
      memberId: '', // 對應商品貸 user_sn
      memberIdType: [
        { key: 0, value: false },
        { key: 1, value: false },
        { key: 2, value: false },
      ], // 0 初發 1 補發 2 換發
      memberIdDate: '', // 日期
      memberIdDateInfo: {
        year: '',
        month: '',
        day: '',
        isRepublic: true,
        startCount: 0,
      },
      memberIdCity: '',
      birthday: '',
      birthdayInfo: {
        year: '',
        month: '',
        day: '',
        isRepublic: true,
        startCount: 0,
      },
      married: [
        { key: 0, value: false },
        { key: 1, value: false },
      ], // 0 未婚 1 已婚
      hasChild: false, // 子女
      childCount: 0, // 幾人
      hasPhone: false,
      phone: '', // 戶籍電話
      hasHomePhone: false,
      homePhone: '', // 住宅電話
      hasCellphone: false,
      cellphone: '', // 行動電話
      isSecret: false, // 保密
      education: '',
      educationLevel: [
        { key: 0, value: false },
        { key: 1, value: false },
        { key: 2, value: false },
        { key: 3, value: false },
        { key: 4, value: false },
        { key: 5, value: false },
      ], // 0博士 1碩士 2大學 3專科 4高中職 5其他
      home: {
        residencePost: '', // 戶籍地郵遞區號 對應商品貸的residence_address_post_zone
        residenceCity: '', // 戶籍縣市
        residenceArea: '', // 戶籍區
        residenceAddress: '', // 戶籍地址
        residenceContent: '',
        residenceTel: '', // 戶籍電話
        homeType1: [
          { key: 0, value: false },
          { key: 1, value: false },
          { key: 2, value: false },
        ], // 0 同戶籍 1 其他 2 公司
        homePost: '', // user_address_post_zone
        homeCity: '', // 現居縣市
        homeArea: '', // 現居區
        homeAddress1: '', // 住宅地址,
        homeContent: '',
        homeTel: '', // 現居電話
        isSameAddress: false, // 同現居地址
        isSamePhone: false, // 同現居電話
        liveYear: '', // 戶籍地居住時間
        liveMonth: '',
        liveLevel: [
          { key: 0, value: false },
          { key: 1, value: false },
          { key: 2, value: false },
          { key: 3, value: false },
          { key: 4, value: false },
          { key: 5, value: false },
        ], // 戶籍 0本人名下 1配偶名下 2親友 3租賃 4宿舍 5其他
        homeType2: [
          { key: 0, value: false },
          { key: 1, value: false },
          { key: 2, value: false },
        ], // 0 同戶籍 1 同住宅 2 其他
        homeAddress2: '', // 住宅地址,
        liveYear2: '', // 通訊地居住時間
        liveMonth2: '',
        liveLevel2: [
          { key: 0, value: false },
          { key: 1, value: false },
          { key: 2, value: false },
          { key: 3, value: false },
          { key: 4, value: false },
          { key: 5, value: false },
        ], // 戶籍 0本人名下 1配偶名下 2親友 3租賃 4宿舍 5其他
      },
      hasMail: false,
      email: '',
      paymentEmail: '',
      usePhonePayment: true, // 預設簡訊
      useElectronicBill: false, // 電子帳單
    };
    this.bankName = ''; // 銀行
    this.bankId = ''; // 銀行代碼  對應商品貸 bank_code
    this.bankSubName = ''; // 分行
    this.bankSubId = ''; // 分行代碼 對應商品貸 bank_branch_code
    this.bankAccount = ''; // 帳號
    this.paymentInfo = new PaymentInfoModel();
    this.company = {
      type: [
        { key: 0, value: false },
        { key: 1, value: false },
        { key: 2, value: false },
      ], // 0無 1家管 2另列如下
      name: '',
      hasPhone: false,
      areaCode: '', // 區碼
      phone: '',
      hasAddress: false,
      city: '',
      area: '',
      address: '',
      title: '',
      workYear: '',
      workMonth: '',
      salary: '', // 月薪
      yearSalary: '', // 年薪
      isSecret: false, // 保密
      companyId: '', // 公司統編
      industry: '', // 產業別
    };
    this.bank = {
      type: [
        { key: 0, value: false },
        { key: 1, value: false },
        { key: 2, value: false },
        { key: 3, value: false },
      ], // 0沒辦過卡 1無卡自停 2協商繳款中 3其他
      otherType: '',
      name: '',
      effectiveYear: '',
      effectiveMonth: '',
      creditCard: '',
    };
    this.firstContact = { // 第一聯絡人
      name: '',
      type: '',
      hasCellphone: false,
      cellphone: '',
      hasHomePhone: false,
      homePhone: '',
      hasCompanyPhone: false,
      companyPhone: '',
      isSecret: false, // 保密
      address: '',
      relationship: 0, // 關係
    };
    this.secondContact = {
      name: '',
      type: '',
      hasCellphone: false,
      cellphone: '',
      hasHomePhone: false,
      homePhone: '',
      hasCompanyPhone: false,
      companyPhone: '',
      isSecret: false, // 保密
      address: '',
      relationship: 0, // 關係
    };
    this.hasJointGuarantor = [
      { key: 0, value: false },
      { key: 1, value: false },
      { key: 2, value: false },
      { key: 3, value: false },
    ]; // 0連帶保證人 1配偶資料僅供參考 2法定代理人 3商品實際使用人
    this.jointGuarantor = {
      name: '',
      type: '',
      relationship: 0, // 關係
      memberId: '',
      memberIdType: [
        { key: 0, value: false },
        { key: 1, value: false },
        { key: 2, value: false },
      ], // 0 初發 1 補發 2 換發
      memberIdDate: '', // 日期
      memberIdDateInfo: {
        year: '',
        month: '',
        day: '',
        isRepublic: true,
        startCount: 0,
      },
      memberIdCity: '',
      education: '',
      educationLevel: [
        { key: 0, value: false },
        { key: 1, value: false },
        { key: 2, value: false },
        { key: 3, value: false },
        { key: 4, value: false },
        { key: 5, value: false },
      ], // 0博士 1碩士 2大學 3專科 4高中職 5其他
      birthday: '',
      birthdayInfo: {
        year: '',
        month: '',
        day: '',
        isRepublic: true,
        startCount: 0,
      },
      phone: '', // 戶籍電話
      hasCellphone: false,
      cellphone: '',
      hasHomePhone: false,
      homePhone: '',
      companyName: '',
      hasTitle: false,
      title: '',
      hasCompanyPhone: false,
      companyTelCode: '', // 公司區碼
      companyPhone: '',
      companySubPhone: '',
      companyAddress: '',
      salary: '', // 月薪
      yearSalary: '', // 年薪
      workYear: '', // 工作年資
      workMonth: '',
      home: {
        residencePost: '',
        residenceAddress: '', // 戶籍地址
        homeType1: [
          { key: 0, value: false },
          { key: 1, value: false },
        ], // 0 同戶籍 2 其他
        homePost: '',
        homeAddress1: '', // 住宅地址,
        liveYear: '', // 居住時間
        liveMonth: '',
        liveLevel: [
          { key: 0, value: false },
          { key: 1, value: false },
          { key: 2, value: false },
          { key: 3, value: false },
          { key: 4, value: false },
          { key: 5, value: false },
        ], // 0本人名下 1配偶名下 2親友 3租賃 4宿舍 5其他
        homeType2: [
          { key: 0, value: false },
          { key: 1, value: false },
          { key: 2, value: false },
        ], // 0 同戶籍 1 同住宅 2 其他
        homeAddress2: '', // 住宅地址,
        liveYear2: '', // 通訊地居住時間
        liveMonth2: '',
        liveLevel2: [
          { key: 0, value: false },
          { key: 1, value: false },
          { key: 2, value: false },
          { key: 3, value: false },
          { key: 4, value: false },
          { key: 5, value: false },
        ], // 戶籍 0本人名下 1配偶名下 2親友 3租賃 4宿舍 5其他
      },
    };
    this.caseInfo = {
      type: [
        { key: 0, value: false },
        { key: 1, value: false },
        { key: 2, value: false },
      ], // 0新件 1補保人 2補資料
      interestRate: [
        { key: 0, value: false },
        { key: 1, value: false },
      ], // 0零利率 1低利率
      category: [
        { key: 0, value: false },
        { key: 1, value: false },
      ], // 0ㄧ般件 1保密件
    };
    this.vendor = {
      productId: '0',
      productName: '',
      deposit: 0, // 訂金
      totalPrice: 0, // 商品總價
      creditPrice: 0, // 貸款金額
      installmentsNumber: 24, // 對應商品貸 regular_total
      creditPriceMonth: 0,
      totalCreditPrice: 0, // 總貸金額
      vendorName: '',
      hasCellphone: false,
      cellphone: '',
      hasFax: false,
      fax: '',
      sameVendor: false,
      salesName: '',
      hasSalesPhone: false,
      salesPhone: '',
      hasSalesCellphone: false,
      salesCellphone: '',
      signature: '',
      type: [
        { key: 0, value: false },
        { key: 1, value: false },
        { key: 2, value: false },
      ], // 0 熟客 1過路客 2指定照會時間
      checkTime: {
        year: '',
        month: '',
        day: '',
        hour: '',
        minute: '',
      },
      comment: '',
    };
    this.promisedNote = { // 本票
      promisedDate: {
        year: '',
        month: '',
        day: '',
      },
      money: {
        one: '',
        two: '',
        three: '',
        four: '',
        five: '',
        six: '',
      },
      paymentCity: '', // 付款地
      createDate: {
        year: '',
        month: '',
        day: '',
      },
    };
    this.approvedDate = {
      year: '',
      month: '',
      day: '',
      isRepublic: false,
      disabled: false,
    };
    this.agree = [
      { key: 0, value: false },
      { key: 1, value: false },
      { key: 2, value: false },
      { key: 3, value: false },
    ];
    this.carInfo = {
      carId: '',
      name: '',
      memberId: '',
      relationship: [
        { key: 0, value: false },
        { key: 1, value: false },
        { key: 2, value: false },
        { key: 3, value: false },
        { key: 4, value: false },
        { key: 5, value: false },
        { key: 6, value: false },
      ],
    };
    this.agentId = '';
    this.confirmAgentId = '';
    this.parentAgent = null;
    this.confirmAgent = null;
    this.createDate = getNow();
    this.status = 0; // 0進件中 1婉拒 2待捕 3核准,
    this.signImage0 = null; // 申請人
    this.signImage0Url = null;
    this.signImage1 = null;
    this.signImage1Url = null;
    this.signImage2 = null;
    this.signImage2Url = null;
    this.signImage3 = null; // 保人簽名
    this.signImage3Url = null;
    this.insureAgent = '';// 對保人員
    this.insureAmount = 0; // 對保金額
    this.insurePrice = 0; // 對保費
    this.otherName = ''; // 其他費用名稱
    this.otherPrice = 0; // 其他費用金額
    this.memo = ''; // 備註
    this.imageList = ''; // 圖檔
    this.settingPrice = 0; // 設定費
    this.sendDate = ''; // 送件時間
    this.contactName = ''; // 經辦人
    this.contactPhone = ''; // 經辦人電話
    this.appropriation = 0; // 實撥金額
    this.requestDoc = null; // 請款文件檔案
    this.requestDocUrl = null; // 請款文件網址
    this.settingDoc = null; // 設定書檔案
    this.settingDocUrl = null; // 設定書網址
    this.requestPayment = null; // 裕富請款文件檔案
    this.requestPaymentURL = null; // 裕富請款文件網址
    this.laonhfcInfo = new LaonhfcModel();
    this.caseInsure = new CaseInsureModel();
    this.files = []; // 商品貸要上傳的圖片資訊陣列，格式參考UseCaseFileModel
    this.useCase = new UseCaseModel();
    this.memberIdImageURL1 = ''; // 身分證正面
    this.memberIdImageURL2 = ''; // 身分證背面
    this.salaryURL = ''; // 薪資證明
    this.phoneVendor = ''; // 手機廠牌
    this.phoneModel = ''; // 手機型號
    this.phoneIMEI = ''; // IMEI碼
    this.isWork8month = false; // 任職是否滿8個月
  }
}



// WEBPACK FOOTER //
// ./src/models/ApplicationModel.js